import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Edit2Icon, LanguagesIcon, Lock, Users2, Book, FileText, HelpCircle } from "lucide-react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { getProfileDetails, updateUserProfile } from "./utilities/ApiCalls";
import axios from "axios";
import Constant from "./Constant";
import { useHistory } from "react-router-dom";
import { deleteAccount } from "./utilities/ApiCalls";
import { Toaster, toast } from "sonner";
import { ClipLoader } from "react-spinners";
import LanguageSelector from "../Componets/LanguageSelector";
import EditPortfolio from "../Componets/EditPortfolio";
import ProfileImage from "../Componets/ProfileImage";
import { setPageTitle } from "../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

export const Setting = ({ initialTab = "edit" }) => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);

  // Get initial tab from location state or props
  const getInitialTab = () => {
    if (location.state?.initialTab) {
      return location.state.initialTab;
    }
    return initialTab;
  };

  const [option, setOption] = useState(getInitialTab());
  const [profile, setprofile] = useState();
  const [loader, setLoader] = useState(false);

  const history = useHistory();
  const { i18n, t } = useTranslation();

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [updateForm, setUpdateForm] = useState({
    name: "",
    email: "",
    dob: "",
    gender: "",
    countryId: "",
    stateId: "",
    cityId: "",
    profilePic: "",
    mobile: "",
    intro: "",
  });

  useEffect(() => {
    if (profile) {
      setUpdateForm({
        name: profile.name || "",
        userName: profile.userName || "",
        email: profile.email || "",
        dob: profile.dob || "",
        gender: profile.gender || "",
        countryId: profile.countryId || "",
        stateId: profile.stateId || "",
        cityId: profile.cityId || "",
        profilePic: profile.profilePic || "",
        mobile: profile.mobile || "",
        intro: profile.intro || "",
      });
    }
  }, [profile]);

  const getProfile = () => {
    getProfileDetails().then((response) => {
      setprofile(response.data.data);
    });
  };

  useEffect(() => {
    getProfile();
  }, []);

  function handleFormChange(e) {
    setUpdateForm({
      ...updateForm,
      [e.target.name]: e.target.value,
    });
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    const payload = {
      ...updateForm,
      userId: profile?._id,
    };
    updateUserProfile(payload).then((response) => {
      if (response.status === Constant.statusSuccess) {
        toast.success("Profile updated successfully");
        setTimeout(() => window.location.reload(), 1000);
      } else {
        toast.error(response.message || "Failed to update profile");
      }
    });
  }

  function changeProfilePicture(event) {
    try {
      let token = localStorage.getItem("loginDetails");
      let image = event.target.files[0];
      const form_data = new FormData();

      let extension = image.name.split(".").pop();
      if (
        extension !== "jpg" &&
        extension !== "png" &&
        extension !== "JPG" &&
        extension !== "PNG"
      ) {
        toast.error("Only jpg and png file type are allowed!");
        return false;
      }

      form_data.append("userProfile", image, image.name);

      axios
        .post(Constant.apiBasePath + "user/updateProfilePic", form_data, {
          headers: { token: token },
        })
        .then((response) => {
          if (response.data.status === Constant.statusSuccess) {
            toast.success("Your profile pic uploaded successfully.");
            setTimeout(function () {
              window.location.reload();
            }, 1000);
          } else {
            toast.error(response.data.message);
          }
        });
    } catch (err) {
      console.error(err);
    }
  }

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com")) return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  const DeleteAccount = async () => {
    try {
      setLoader(true);
      const result = await deleteAccount(profile._id);
      setTimeout(() => {
        localStorage.removeItem("loginDetails");
        setLoader(false);
        toast.success(t("Settings.DeleteSuccess"));
        window.location.href = "/login";
      }, 2000);
    } catch (error) {
      console.error("Error deleting user account", error);
      setLoader(false);
    }
  };

  return (
    <Layout>
      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          height: "100vh",
          minHeight: "fit-content",
          overflow: "auto",
        }}
      >
        <Root>
          {windowSize.width > 700 ? (
            <div className="setting-container">
              <div className="side-bar">
                <div className="account-settings-header">ACCOUNT SETTINGS</div>
                <div
                  onClick={() => setOption("edit")}
                  className={`cart ${option === "edit" ? "active" : ""}`}
                >
                  <Edit2Icon size={18} />
                  <div className="title">
                    {t("Settings.EditProfile.EditProfile")}
                  </div>
                </div>

                <div
                  onClick={() => setOption("language")}
                  className={`cart ${option === "language" ? "active" : ""}`}
                >
                  <LanguagesIcon size={18} />
                  <div className="title">{t("Settings.Language")}</div>
                </div>
                <div
                  onClick={() => setOption("portfolio")}
                  className={`cart ${option === "portfolio" ? "active" : ""}`}
                >
                  <Book size={18} />
                  <div className="title">
                    {t("Settings.EditPortfolio", "Edit eBook")}
                  </div>
                </div>
                <Link to={`/privacy-policy`} className="cart">
                  <Lock size={18} />
                  <div className="title">{t("Settings.AccountPrivacy")}</div>
                </Link>
                <Link to={`/term-condition`} className="cart">
                  <FileText size={18} />
                  <div className="title">{t("Settings.TermsConditions", "Terms & Conditions")}</div>
                </Link>
                <Link to={`/about-us`} className="cart">
                  <Users2 size={18} />
                  <div className="title">{t("Settings.AboutUS")}</div>
                </Link>
                <Link to={`/faqs`} className="cart">
                  <HelpCircle size={18} />
                  <div className="title">{t("Settings.FAQs", "FAQs")}</div>
                </Link>
                <button
                  className={`cart-del ${option === "Del" ? "active" : ""}`}
                  onClick={() => setOption("Del")}
                >
                  <Users2 size={18} />
                  <div className="title">{t("Settings.DeleteAccount")}</div>
                </button>
              </div>

              <div className="main">
                {option == "edit" && (
                  <div className="profile-container">
                    <h1 className="page-title">Public Profile</h1>
                    <p className="page-subtitle">
                      Manage how your profile appears to other writers and
                      readers.
                    </p>

                    <div className="profile-image-section">
                      <div className="profile-image-wrapper">
                        <ProfileImage
                          src={profile?.profilePic}
                          name={profile?.name}
                          size={70}
                          className="profile-img"
                          alt="profile"
                          proxiedUrl={proxiedUrl}
                          avatarProps={{
                            className: "profile-img-default",
                          }}
                        />
                      </div>
                      <div className="profile-actions">
                        <label
                          htmlFor="file-input"
                          className="change-photo-btn"
                        >
                          Change Photo
                        </label>
                        <input
                          id="file-input"
                          type="file"
                          onChange={changeProfilePicture}
                          accept="image/png, image/jpg"
                          style={{ display: "none" }}
                        />
                        <button type="button" className="remove-photo-btn">
                          Remove
                        </button>
                      </div>
                    </div>

                    <form className="form">
                      <div className="form-group">
                        <label className="label">USERNAME</label>
                        <input
                          name="userName"
                          value={updateForm.userName}
                          onChange={(e) => {
                            setUpdateForm({
                              ...updateForm,
                              userName: e.target.value,
                            });
                          }}
                          className="input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">BIO</label>
                        <textarea
                          name="intro"
                          className="input textarea"
                          value={updateForm.intro || ""}
                          onChange={handleFormChange}
                        ></textarea>
                        <span className="helper-text">
                          Brief description for your profile. Max 160
                          characters.
                        </span>
                      </div>
                      <div className="form-group">
                        <label className="label">
                          {t("Settings.EditProfile.DOB")}
                        </label>
                        <input
                          type="date"
                          name="dob"
                          value={updateForm.dob}
                          onChange={handleFormChange}
                          className="input"
                          placeholder="dd-mm-yyyy"
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">
                          {t("Settings.EditProfile.ContactNumber")}
                        </label>
                        <input
                          type="text"
                          name="mobile"
                          value={updateForm.mobile || ""}
                          onChange={handleFormChange}
                          className="input"
                        />
                      </div>
                      <div className="form-group">
                        <label className="label">
                          {t("Settings.EditProfile.EmailId")}
                        </label>
                        <input
                          name="email"
                          value={updateForm.email}
                          onChange={handleFormChange}
                          className="input disabled"
                          disabled
                        />
                        <span className="helper-text">
                          Contact support to change your email address.
                        </span>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          className="cancel-btn"
                          onClick={() => window.location.reload()}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          onClick={handleFormSubmit}
                          className="save-btn"
                        >
                          Save Changes
                        </button>
                      </div>
                    </form>
                  </div>
                )}

                {option == "language" && <LanguageSelector i18n={i18n} />}
                {option == "portfolio" && <EditPortfolio />}
                {option === "Del" && (
                  <div>
                    <div className="del-div">
                      <h1 style={{ color: "var(--color-text)" }}>
                        {t("Settings.DeleteAccount")}
                      </h1>
                      <p
                        style={{
                          fontSize: "18px",
                          color: "var(--color-text-secondary)",
                          textAlign: "center",
                          marginBottom: "20px",
                        }}
                      >
                        {t("Settings.AreYouSureDelete")}{" "}
                      </p>
                      <div className="del-containerbtn">
                        <button className="del-btn" onClick={DeleteAccount}>
                          {t("Settings.DeleteButton")}
                        </button>
                      </div>
                    </div>
                    {loader && (
                      <div className="overlay">
                        <div className="popup">
                          <ClipLoader color="var(--color-text)" size={50} />
                          <h1 style={{ color: "var(--color-text)" }}>
                            {t("Settings.Deleting")}
                          </h1>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className="setting-container-mobile">
              <div className="side-bar-mobile">
                <Link to={`/setting/edit`} className="cart-mobile">
                  <Edit2Icon size={18} />
                  <div className="title">
                    {t("Settings.EditProfile.EditProfile")}
                  </div>
                </Link>
                <div
                  onClick={() => {
                    setOption("language");
                  }}
                  style={{ cursor: "pointer" }}
                  className="cart-mobile"
                >
                  <LanguagesIcon size={18} />
                  <div className="title">{t("Settings.Language")}</div>
                </div>
                <Link to={`/setting/portfolio`} className="cart-mobile">
                  <Book size={18} />
                  <div className="title">
                    {t("Settings.EditPortfolio", "Edit eBook")}
                  </div>
                </Link>
                <Link to={`/privacy-policy`} className="cart-mobile">
                  <Lock size={18} />
                  <div className="title">{t("Settings.AccountPrivacy")}</div>
                </Link>
                <Link to={`/term-condition`} className="cart-mobile">
                  <FileText size={18} />
                  <div className="title">{t("Settings.TermsConditions", "Terms & Conditions")}</div>
                </Link>

                <Link to={`/about-us`} className="cart-mobile">
                  <Users2 size={18} />
                  <div className="title">{t("Settings.AboutUS")}</div>
                </Link>
                <Link to={`/faqs`} className="cart-mobile">
                  <HelpCircle size={18} />
                  <div className="title">{t("Settings.FAQs", "FAQs")}</div>
                </Link>
                <Link to={`/delete-account`} className="cart-mobile">
                  <Users2 size={18} />
                  <div className="title">{t("Settings.DeleteAccount")}</div>
                </Link>
              </div>

              {option === "language" && (
                <div
                  className="language-modal-overlay"
                  onClick={() => setOption("edit")}
                >
                  <div
                    className="language-modal"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="language-modal-header">
                      <h2>{t("Settings.Language")}</h2>
                      <button
                        type="button"
                        className="language-modal-close"
                        onClick={() => setOption("edit")}
                      >
                        {t("Settings.Close")}
                      </button>
                    </div>
                    <LanguageSelector i18n={i18n} />
                  </div>
                </div>
              )}
            </div>
          )}
          <Toaster />
        </Root>
      </div>
    </Layout>
  );
};

const Root = styled.div`
  min-height: 800px;
  height: auto;
  display: flex;
  max-width: 1300px;
  width: 100%;
  justify-content: center;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  color: var(--color-text);

  .account-settings-header {
    font-size: 12px;
    font-weight: 600;
    color: var(--color-text-tertiary);
    letter-spacing: 1px;
    margin-bottom: 10px;
    padding-left: 20px;
    text-transform: uppercase;
  }

  .setting-container {
    display: flex;
    width: 100%;
    margin-top: 40px;
    gap: 0;
  }

  .side-bar {
    width: 280px;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-right: 20px;
  }

  .cart {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    gap: 12px;
    color: var(--color-text-tertiary);
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.2s;
    cursor: pointer;
    font-size: 15px;
  }

  .cart:hover {
    background-color: var(--color-surface);
    color: var(--color-text);
  }

  .cart.active {
    background-color: var(
      --color-surface
    ); // Changed from color-secondary to match screenshot likely or keep selection style but maybe subtle
    color: var(--color-text);
    font-weight: 500;
  }

  /* Retain previous active style if user prefers or adjust to match design? 
     The design shows green active state.
  */
  .cart.active {
    background-color: #e6f0e6; /* Approximate light green from image */
    color: #1a1a1a;
  }

  .cart-del {
    background: none;
    border: none;
    text-align: left;
    font-size: 15px;
    cursor: pointer;
    color: var(--color-error);
    display: flex;
    align-items: center;
    padding: 12px 20px;
    gap: 12px;
    width: 100%;
    border-radius: 8px;
  }

  .cart-del:hover {
    background-color: var(--color-surface);
  }

  .cart-del.active {
    background-color: var(--color-surface);
    font-weight: 500;
  }

  .main {
    flex: 1;
    background: var(--color-surface);
    padding: 40px;
    height: fit-content;
    border: 1px solid var(--color-border);
    border-radius: 8px;
    margin-left: 20px;
  }

  .profile-container {
    max-width: 800px;
    width: 100%;
  }

  .page-title {
    font-family: serif;
    font-size: 32px;
    font-weight: 700;
    margin-bottom: 4px;
    color: var(--color-text);
  }

  .page-subtitle {
    font-size: 14px;
    color: var(--color-text-tertiary);
    margin-bottom: 24px;
  }

  .profile-image-section {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 24px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--color-border);
  }

  .profile-image-wrapper {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    background-color: var(--color-surface);
  }

  .profile-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .profile-actions {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  .change-photo-btn {
    padding: 6px 14px;
    border: 1px solid var(--color-border);
    background: var(--color-surface);
    border-radius: 4px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    color: var(--color-text);
    transition: all 0.2s;
  }

  .change-photo-btn:hover {
    background-color: var(--color-background);
    border-color: var(--color-text-secondary);
  }

  .remove-photo-btn {
    background: none;
    border: none;
    color: var(--color-error);
    font-size: 13px;
    cursor: pointer;
    font-weight: 500;
  }

  .remove-photo-btn:hover {
    text-decoration: underline;
  }

  .form {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .label {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--color-text-tertiary);
    margin: 0;
    letter-spacing: 0.5px;
  }

  .input {
    padding: 6px 10px;
    border: 1px solid var(--color-border);
    border-radius: 4px;
    font-size: 14px;
    color: var(--color-text);
    outline: none;
    background: var(--color-surface);
    transition: border-color 0.2s;
    width: 100%;
  }

  .input:focus {
    border-color: var(--color-text);
  }

  .input.disabled {
    background-color: var(--color-surface);
    color: var(--color-text-secondary);
    opacity: 0.7;
    cursor: not-allowed;
  }

  .textarea {
    min-height: 80px;
    resize: vertical;
    font-family: inherit;
  }

  .helper-text {
    font-size: 12px;
    color: var(--color-text-tertiary);
    margin-top: -4px;
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    margin-top: 8px;
    padding-top: 12px;
    border-top: 1px solid var(--color-border);
  }

  .cancel-btn {
    padding: 10px 20px;
    border: none;
    background: none;
    color: var(--color-text-secondary);
    font-size: 14px;
    cursor: pointer;
    font-weight: 500;
  }

  .cancel-btn:hover {
    color: var(--color-text);
  }

  .save-btn {
    padding: 10px 24px;
    background-color: var(--color-primary);
    color: var(--color-surface);
    border: none;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
  }

  .save-btn:hover {
    opacity: 0.9;
  }

  /* Overlay */
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .popup {
    background-color: var(--color-surface);
    padding: 30px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .del-div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }

  .del-btn {
    padding: 12px 24px;
    background-color: var(--color-error);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
  }

  .del-btn:hover {
    opacity: 0.9;
  }

  /* Mobile */
  .setting-container-mobile {
    width: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .side-bar-mobile {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .cart-mobile {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: var(--color-surface);
    border-radius: 8px;
    text-decoration: none;
    color: var(--color-text);
    gap: 15px;
  }

  .language-modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .language-modal {
    background: var(--color-surface);
    border-radius: 12px;
    padding: 20px;
    width: 90%;
    max-width: 400px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  }

  .language-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .language-modal-header h2 {
    margin: 0;
    font-size: 18px;
    color: var(--color-text);
  }

  .language-modal-close {
    border: none;
    background: none;
    color: var(--color-text-secondary);
    font-size: 14px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    .setting-container {
      flex-direction: column;
    }
    .side-bar {
      width: 100%;
      border-right: none;
      border-bottom: 1px solid var(--color-border);
      padding-bottom: 20px;
    }
  }
`;
